const SEARCH_INPUT_OPENER_CLASS = 'store-search-input-opener';
const SEARCH_INPUT_WRAPPER_QUERY_SELECTOR = '.store-search-input-wrapper';
const SEARCH_INPUT_OPENED_CLASS = 'store-search-input-wrapper--opened';
const SEARCH_INPUT_DROPDOWN_QUERY_SELECTOR = '.store-search-input-dropdown';
const SEARCH_INPUT_ITEM_CLASS = 'store-search-input-item';
const SEARCH_INPUT_ITEM_CHECKBOX_QUERY_SELECTOR = 'input[type="checkbox"]';
const SEARCH_INPUT_QUERY_SELECTOR = 'input[type="search"]';

const hideSearchInput = (inputWrapperElement) => {
    inputWrapperElement.classList.remove(SEARCH_INPUT_OPENED_CLASS);
    const checkboxElements = inputWrapperElement.querySelectorAll(SEARCH_INPUT_ITEM_CHECKBOX_QUERY_SELECTOR);

    if (checkboxElements && checkboxElements.length > 0) {
        checkboxElements.forEach(checkboxElement => {
            checkboxElement.checked = false;
        });
    }
}

const handleCloseButtonClick = (buttonElement) => {
    const inputWrapperElement = buttonElement.closest(SEARCH_INPUT_WRAPPER_QUERY_SELECTOR);
    if (inputWrapperElement) {
        hideSearchInput(inputWrapperElement);
    }
}

const handleConfirmButtonClick = (buttonElement) => {
    const inputWrapperElement = buttonElement.closest(SEARCH_INPUT_WRAPPER_QUERY_SELECTOR);

    const checkboxElements = inputWrapperElement.querySelectorAll(SEARCH_INPUT_ITEM_CHECKBOX_QUERY_SELECTOR);

    if (!checkboxElements || checkboxElements.length === 0) {
        return;
    }

    const storeSlugs = [];

    checkboxElements.forEach(checkboxElement => {
        const shouldPushSlug = checkboxElement.checked && checkboxElement.dataset.storeSlug;

        if (shouldPushSlug) {
            storeSlugs.push(checkboxElement.dataset.storeSlug);
        }
    });

    document.location.replace(`${document.location.pathname}${storeSlugs.length > 0 ? `?store=${storeSlugs.join(',')}` : ''}`);
}

export const initSearchInput = () => {
    const searchInputOpenerElements = document.getElementsByClassName(SEARCH_INPUT_OPENER_CLASS);

    if (!searchInputOpenerElements || searchInputOpenerElements.length === 0) {
        return;
    }

    for (const searchInputOpenerElement of searchInputOpenerElements) {
        searchInputOpenerElement.onclick = openSearchDropdown;

        const searchElement = searchInputOpenerElement.parentElement.querySelector(SEARCH_INPUT_QUERY_SELECTOR);
        if (searchElement) {
            searchElement.oninput = handleFilterElements;
        }
    }

    document.addEventListener('click', function(event) {
        const elementDataset = event.target.dataset;
        if (elementDataset && elementDataset.action === 'confirm') {
            handleConfirmButtonClick(event.target);
            return;
        } else if (elementDataset && elementDataset.action === 'cancel') {
            handleCloseButtonClick(event.target);
            return;
        }

        for (let i = 0; i < searchInputOpenerElements.length; i++) {
            const searchInputOpenerElement = searchInputOpenerElements[i];
            const inputWrapperElement = searchInputOpenerElement.closest(SEARCH_INPUT_WRAPPER_QUERY_SELECTOR);

            const isProductImageShown = inputWrapperElement.classList.contains(SEARCH_INPUT_OPENED_CLASS);
            const isClickOnSearchInput = inputWrapperElement.contains(event.target);

            if (!isClickOnSearchInput && isProductImageShown) {
                hideSearchInput(inputWrapperElement);
            }
        }
    });
}

const openSearchDropdown = (e) => {
    const inputWrapperElement = e.target.closest(SEARCH_INPUT_WRAPPER_QUERY_SELECTOR);

    if (inputWrapperElement) {
        inputWrapperElement.classList.toggle(SEARCH_INPUT_OPENED_CLASS);   
    }
}

const handleFilterElements = (e) => {
    const dropdownElement = e.target.closest(SEARCH_INPUT_DROPDOWN_QUERY_SELECTOR);
    if (!dropdownElement) {
        return;
    }

    const optionElements = dropdownElement.getElementsByClassName(SEARCH_INPUT_ITEM_CLASS);
    const searchedText = e.target.value ? e.target.value.toLowerCase() : '';

    if (!optionElements || optionElements.length === 0) {
        return;
    }

    for (const optionElement of optionElements) {
        const labelElement = optionElement.querySelector(['label']);

        if (!labelElement) {
            return;
        }

        const isSearched = labelElement.innerText.toLowerCase().includes(searchedText);
        optionElement.style.display = isSearched ? 'block' : 'none'
    }
}
